import {createReducer} from '../utils/createReducer'

const namespace = 'news';


const initialState = {
  newsinfo: undefined,
  newspic: undefined,
};

const reducers = {
  onGetNewsListSuc(state = initialState, action){
    if (action.error){
      return state
    }
    return {...state, newsinfo: JSON.parse(action.result.content)}
  },
  onGetNewsPicSuc(state = initialState, action){
    if (action.error){
      return state
    }
    return {...state, newspic: JSON.parse(action.result.content) }
  }
};


export default createReducer(initialState, reducers, namespace);





// WEBPACK FOOTER //
// ./src/reducers/news.js